import { Model, Attr, HasMany } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'

@Model()
export default class Country extends ApplicationRecord {
  static jsonapiType = 'countries'

  @Attr() id!: string
  @Attr() name!: string
  @Attr() code!: string
  @Attr() createdAt!: string
  @Attr() updatedAt!: string

  @HasMany('regions') regions!: any[]
}
